// extracted by mini-css-extract-plugin
module.exports = {"label":"expressRecord_label__2ShIG"};